module.exports = __webpack_public_path__ + "img/CL-dark.8b24c152.png";